import { render, staticRenderFns } from "./ViewInvoice.vue?vue&type=template&id=97524646&scoped=true&"
import script from "./ViewInvoice.vue?vue&type=script&lang=ts&"
export * from "./ViewInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./ViewInvoice.vue?vue&type=style&index=0&id=97524646&lang=sass&scoped=true&"
import style1 from "./ViewInvoice.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97524646",
  null
  
)

export default component.exports